/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ZandaHealth API
 * OpenAPI spec version: 1.0
 */

export type StripePaymentSource =
  (typeof StripePaymentSource)[keyof typeof StripePaymentSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StripePaymentSource = {
  ClinicAppInvoice: 0,
  ClinicAppPayment: 1,
  ClinicAppAppointmentPanel: 2,
  ClientPortalInvoicePayment: 3,
  ClientPortalAppointmentBooking: 5,
  ClinicAppPaymentUpdate: 6,
} as const;
